import { render, staticRenderFns } from "./CreateFolder.vue?vue&type=template&id=4b61ec5c&scoped=true"
import script from "./CreateFolder.vue?vue&type=script&lang=ts"
export * from "./CreateFolder.vue?vue&type=script&lang=ts"
import style0 from "./CreateFolder.vue?vue&type=style&index=0&id=4b61ec5c&prod&lang=scss&scoped=true"
import style1 from "./CreateFolder.vue?vue&type=style&index=1&id=4b61ec5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61ec5c",
  null
  
)

export default component.exports